import style from './CarouselListing.css';
import CarouselListItem from '../CarouselItem/CarouselListItem';
import { useState } from 'preact/hooks';
import { _className } from '../../../utils/classname.utils';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import { LanguageCode, LanguageId } from '../../../localization/language';

export default function CarouselListing({ items = [], onButtonClick }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(null);
  const [offsetX, setOffsetX] = useState(0);
  const { t, getLanguageId } = useTranslation();

  function handleContinue() {
    if (currentIndex == items.length - 1) {
      onButtonClick();
      return;
    }

    setCurrentIndex(prevIndex => (prevIndex + 1) % items.length);
  }

  function isLeftToRight() {
    return getLanguageId() === LanguageId[LanguageCode.ENGLISH];
  }

  const handleTouchStart = e => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = e => {
    if (startX !== null) {
      const currentX = e.touches[0].clientX;
      const diff = currentX - startX;
      setOffsetX(diff);
    }
  };

  const handleTouchEnd = () => {
    isLeftToRight() ? handleLeftToRightSwipe() : handleRightToLeftSwipe();
  };

  function handleLeftToRightSwipe() {
    setStartX(null);
    if (offsetX > 50 && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else if (offsetX < -50 && currentIndex < items.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (currentIndex == items.length - 1) {
      onButtonClick();
    }
    setOffsetX(0);
  }

  function handleRightToLeftSwipe() {
    setStartX(null);
    if (offsetX < -50 && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else if (offsetX > 50 && currentIndex < items.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (currentIndex == items.length - 1) {
      onButtonClick();
    }
    setOffsetX(0);
  }

  return (
    <div
      className={style.carousel}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={style['carousel-inner']}
        style={{
          transform: `translateX(${isLeftToRight() ? '-' : ''}${
            currentIndex * 100
          }%)`,
        }}
      >
        {items.map((item, index) => (
          <div key={index} className={style['carousel-view']}>
            <CarouselListItem key={item.id} item={item} />
          </div>
        ))}
      </div>
      <div className={style['dots-container']}>
        {items.map((_, index) => (
          <div
            key={index}
            className={`${style.dot} ${_className(
              index === currentIndex,
              style['dot--active'],
            )}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
      <div className={style['button-container']}>
        <Button
          onClick={() => {
            handleContinue();
          }}
        >
          {t('Continue')}
        </Button>
      </div>
    </div>
  );
}
